var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active_status==1 || (_vm.active_status==0&&_vm.wait_active_cnt==1) )?_c('div',{staticClass:"kfFixed2"},[_c('img',{attrs:{"border":"0","src":"https://static.ccxia.cn/Uploads/lottery/2301/63b647a7c0b7e.png","alt":"点击这里给我发消息","title":"点击这里给我发消息"}}),_vm._v(" "),_c('p',[_vm._v("扫码咨询客服")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-7cb10dc5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/kefubox.vue
// module id = null
// module chunks = 